import {
    anthropicTextModelsOptions,
    openAiTextModelsOptions,
    providersOptions,
    groqTextModelsOptions,
    bedrockTextModelsOptions,
} from '../types'
import FormikTextField from 'components/TextFieldFormik/TextFieldFormik'

import Slider from 'components/Slider'
import { StyledRow } from './SettingsStyles.css'
import DropdownFormik from 'components/DropdownFormik'
import { useEffect, useState } from 'react'

const getModelOptions = (provider: string) => {
    switch (provider) {
        case 'OpenAI':
            return openAiTextModelsOptions
        case 'Anthropic':
            return anthropicTextModelsOptions
        case 'Groq':
            return groqTextModelsOptions
        case 'Bedrock':
            return bedrockTextModelsOptions
        default:
            return []
    }
}

const StreamPromptingSettings = ({ formik }: { formik: any }) => {
    const [modelOptions, setModelOptions] = useState(getModelOptions(formik.values.provider))

    useEffect(() => {
        const newModelOptions = getModelOptions(formik.values.provider)
        formik.setFieldValue('model', newModelOptions[0]?.value || '')
        setModelOptions(newModelOptions)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.provider])

    return (
        <>
            <>
                <DropdownFormik
                    label={'Provider'}
                    fieldName={'provider'}
                    fieldValue={formik.values.provider}
                    options={providersOptions}
                    setFieldValue={formik.setFieldValue}
                />
                <DropdownFormik
                    label={'Model'}
                    fieldName={'model'}
                    fieldValue={formik.values.model}
                    options={modelOptions}
                    setFieldValue={formik.setFieldValue}
                />
            </>

            <FormikTextField name='seed' placeholder={'seed'} label={'Seed'} type='number' />

            <Slider
                name='temperature'
                label='Temperature'
                min={0}
                max={1}
                step={0.1}
                value={formik.values.temperature}
                onChange={value => formik.setFieldValue('temperature', value)}
            />
            <Slider
                name='max_tokens'
                label='Max Tokens'
                min={1}
                max={4096}
                step={1}
                value={formik.values.max_tokens}
                onChange={value => formik.setFieldValue('max_tokens', value)}
            />

            <StyledRow>
                <FormikTextField name='top_k' placeholder={'top_k'} label={'top_k'} type='number' />
                <FormikTextField name='top_p' placeholder={'top_p'} label={'top_p'} type='number' />
            </StyledRow>

            <FormikTextField
                name='timeout'
                placeholder={'timeout'}
                label={'Timeout'}
                type='number'
            />
        </>
    )
}

export default StreamPromptingSettings
